import { Component, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TokenStorageService } from '../../services/safeguard/token-storage.service';
import { SharedService } from "../../shared/services/shared.service";
import { IdleMonitorService } from '../../services/safeguard/idle-monitor.service';
import { UserContextService } from '../../services/safeguard/user-context.service';
import { SharedSignalService } from '../../services/config/shared-signal.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent {

  @Output() public sidenavToggle = new EventEmitter();

  isUserAuthenticated: boolean = false;

  loginEventSubscription: Subscription;
  browserRefreshEventSubscription: Subscription;
  
  appVerion: string = "v.2026-07.1";
  environmentBanner: string = environment.env.banner;
  isProdEnvironment: boolean = environment.production;
  appRegion: string = environment.env.name.includes("PROD") ? '' : "@ " + environment.env.name;

   constructor(
    private readonly router: Router,
    private readonly sharedService: SharedService, 
    private readonly tokenStorageService: TokenStorageService,    
    private readonly userContextService: UserContextService,
    private readonly sharedSignalService: SharedSignalService,
    private readonly idleMonitorService: IdleMonitorService) { 
      this.loginEventSubscription = this.tokenStorageService.getLoginEvent().subscribe((userLoggedIn: boolean)=>{
          this.isUserAuthenticated = userLoggedIn;
      })
      this.browserRefreshEventSubscription = this.tokenStorageService.getBrowserRefreshEvent().subscribe((browserRefresh: boolean) => {
        if (browserRefresh && this.userContextService.isUserAuthenticated()) {
          this.isUserAuthenticated = true;
        }
      })
    }
 
  // ngOnInit() {
  // }
 
  public onToggleSidenav = () => {
    this.sidenavToggle.emit();
  }

  public isUserAuthenticatedX (): boolean {
    return this.userContextService.isUserAuthenticated();
  }


  // Find out whether the current user has ALL the privileges from the list
  public hasAllPrivileges (priveleges: string[]): boolean {
    return this.userContextService.userHasAllPrivileges(priveleges);
  }

  // Find out whether the current user has at least one privilege from the list
  public hasAnyPrivilege (priveleges: string[]): boolean {
    return this.userContextService.userHasAllPrivileges(priveleges);
  }

  // Find out whether the current user has a required privilege
  public hasPrivilege (privilege: string): boolean {
    return this.userContextService.userHasPrivilege(privilege);
  }

  navigateMenu(tag: string){
    if (tag === 'home'){
         this.router.navigate(['/home']);
        }
    if (tag === 'homeBiller'){
          this.router.navigate(['/homeBiller']);
        }
    if (tag === 'portalUsers'){
        this.router.navigate(['/portalUsers']);
        }
    if (tag === 'monitoring'){
        this.router.navigate(['/monitoring']);
       }
    if (tag === 'accountInfo'){
      this.router.navigate(['/accountInfo']);
    }
    if (tag === 'enrollments'){
      this.router.navigate(['/enrollmentReport']);
    }
    if (tag === 'csr-account') {
      this.router.navigate(['/csr-account'])
    }
    if (tag === 'logout'){
      this.sharedService.clearUserSession();

      // make the actual logout
      this.idleMonitorService.stopWatching();
      this.tokenStorageService.sendLoginEvent();
      this.tokenStorageService.signOut();
      this.router.navigate(['/login']);
      this.sharedSignalService.setHasEnrollmentSimulator(false);

    }
  }


}
